export default __webpack_public_path__ + "static/media/joint-web-developer.69b69c51.jpg";